"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationDashboard',
  data: function data() {
    return {
      loading: false,
      metrics: []
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationDashboardApi)().then(function (data) {
        _this.metrics = data && data.metrics || [];
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};